var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({staticClass:"lang-select mx-auto",attrs:{"dark":"","filled":"","append-icon":"mdi-web","value":_vm.$i18n.locale,"items":_vm.LANGUAGES},on:{"change":_vm.setLanguage}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }